/** Backend middleware expects Bearer {sessionId}&{organizationId}, not a JWT. */
function backendBearerCredential(sessionId, organizationId, token) {
  const t = typeof token === "string" ? token.trim() : "";
  if (t.includes("&")) return t;
  const sid = String(sessionId || "").trim();
  const oid = String(organizationId || "").trim();
  return `${sid}&${oid}`;
}

export async function updateScore({
  sessionId,
  organizationId,
  users,
  role,
  token,
  gameId,
}) {
  const bearer = backendBearerCredential(sessionId, organizationId, token);
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateScore`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearer}`,
    },
    body: JSON.stringify({
      sessionId,
      organizationId,
      users,
      role,
      token,
      gameId,
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.error || data?.message || "Failed to update score");
  }
  return data;
}
